import { createReducer } from '@reduxjs/toolkit';
import * as actionTypes from 'modules/customers/actionTypes';

/** @typedef {string | {errorCode: number, errorStatus: string, errorMessage: string} | null} ApiErrorState */
const initialState = null;

const reset = () => null;
const set = (_, { payload }) => payload.error;

export default createReducer(initialState, (builder) => {
  builder
    .addCase(actionTypes.POST_CUSTOMER_LEADS_UNSUBSCRIBE, reset)
    .addCase(actionTypes.POST_CUSTOMER_LEADS_UNSUBSCRIBE_FAILURE, set);
});
